import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_shifts_and_hours_of_operation_for_each_normal_operations'

export const dataPointDefinition = {
  retracedId: 'num_of_shifts_and_hours_of_operation_for_each_normal_operations',
  name: 'Number of Shifts and Hours of Operation for each (Normal Operations):',
  description:
    'The number of shifts during normal operations that occur during a 24-hour period and the hours that make up each shift (e.g. 2 shifts 7:00-15:30 and 15:30 to 0:00).',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bi-10',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 530,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
